import { useEffect } from 'react';
import { useLocationTracking } from '../hooks/use-location-tracking';
import { useAuth } from '../stores/auth';

/**
 * Starts GPS tracking automatically after login.
 * Runs silently — no UI. Pings every 60s, syncs via batch API.
 * Must be mounted inside the authenticated section of App.tsx.
 */
export function GlobalLocationTracker() {
  const { isAuthenticated } = useAuth();
  const { isTracking, start, stop } = useLocationTracking();

  useEffect(() => {
    if (isAuthenticated) {
      start();
    }
    return () => {
      stop(); // always safe — idempotent
    };
  }, [isAuthenticated]); // eslint-disable-line react-hooks/exhaustive-deps

  return null; // no UI
}
